var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('Topbar',{staticClass:"mobileTopBar sticky-top"}),_c('Sidebar'),_c('div',{attrs:{"id":"topbar_id"}},[_c('Topbar',{staticClass:"webTopBar"}),_c('BannerHeader')],1),_c('MainMenu'),_c('Sidebar'),_c('Content'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }